export { default } from './opinion-snippet-block';